import { fetchApi } from "containers/helpers";

export const getMissionAppointmentReviews = contractId => fetchApi(`/review/appointment/${contractId}`)